<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content"  :coordinates="coordinates">			
			<div class="modal__head">
				<div class="modal__head__title">{{areaTitle}}</div>
				<div class="modal__head__subtitle">{{areaDesc}}</div>
			</div>
			<div class="modal__content" style="padding:0;">
				<img :src="cords" alt="">
			</div>

		</div>


	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';

    

	export default {
		props : ['coordinates', 'areaId', 'areaTitle', 'areaDesc'],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'previewStaticMapModal' + this.areaId,
				url : this.fullStaticMapUrl
			}
		},
		computed : {
			cords(){
				return this.fullStaticMapUrl();
			},
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			},
			propCords(){
				return this.coordinates;
			}
			
		},
		methods : {
			fullStaticMapUrl(){
				
				let parsedCoords = JSON.parse(this.propCords);
				let coordQuerystr = "";
				let APIK = "key=" + process.env.GOOGLE_MAPS_API;
	

				// parse coordinates into js
				let firstCoord = "";
				parsedCoords.forEach((cord, i) => {

					coordQuerystr += `C${cord.lat},${cord.lng}%7`;
					if(i == 0){
						firstCoord = `C${cord.lat},${cord.lng}%7`;
					}
				})
				// remove the last pipe
				coordQuerystr += firstCoord;
				coordQuerystr = coordQuerystr.slice(0, -1);
				coordQuerystr = coordQuerystr.slice(0, -1);

				// get center
				let centerObj = this.polygonCenter(parsedCoords);
				let lat = centerObj.lat();
				let lng = centerObj.lng();
				
				let baseURL = `http://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&size=600x400&maptype=roadmap&sensor=false&path=color%3ablue%7Cweight:2%7${coordQuerystr}` + '&' + APIK;
		
			
				return baseURL;
			},
			polygonCenter(poly) {
			    var lowx,
			        highx,
			        lowy,
			        highy,
			        lats = [],
			        lngs = [],
			        vertices = poly;

			    for(var i=0; i<vertices.length; i++) {
			      lngs.push(vertices[i].lng);
			      lats.push(vertices[i].lat);
			    }

			    lats.sort();
			    lngs.sort();
			    lowx = lats[0];
			    highx = lats[vertices.length - 1];
			    lowy = lngs[0];
			    highy = lngs[vertices.length - 1];
			    let center_x = lowx + ((highx-lowx) / 2);
			    let center_y = lowy + ((highy - lowy) / 2);
			    return (new google.maps.LatLng(center_x, center_y));
			}
		}
	}
</script>






// WEBPACK FOOTER //
// src/components/common/Modals/previewStaticMapModal.vue